import React, { FormEvent, useState } from "react";
import { useUser } from "@/shared/lib/hooks/useUser/useUser";

export const ProtectedContent = () => {
    const { setUser } = useUser();
    const [question, setQuestion] = useState("Как лечить щитовидную железу");
    const [limit, setLimit] = useState("20");
    const [minRelevance, setMinRelevance] = useState("0.6");
    const [debug, setDebug] = useState(false);
    const [loading, setLoading] = useState(false);
    const [apiResponse, setApiResponse] = useState("");
    const [apiError, setApiError] = useState("");

    const handleApiSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        setApiError("");
        setApiResponse("");

        const requestBody = {
            question: question,
            limit: parseInt(limit),
            min_relevance: parseFloat(minRelevance),
            debug: debug,
        };

        try {
            const response = await fetch("https://rag.dev.myrevive.app/ask", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setApiResponse(JSON.stringify(data, null, 2));
        } catch (err) {
            setApiError((err as Error).message);
        } finally {
            setLoading(false);
        }
    };

    const handleLogout = () => {
        setUser("");
        setApiResponse("");
        setApiError("");
    };

    // @ts-ignore
    // @ts-ignore
    return (
        <div
            style={{
                minHeight: "100vh",
                backgroundColor: "#f0f2f5",
                padding: "20px",
            }}
        >
            <div
                style={{
                    maxWidth: "1200px",
                    margin: "0 auto",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "30px",
                    }}
                >
                    <h1 style={{ margin: 0 }}>RAG API Interface</h1>
                    <button
                        onClick={handleLogout}
                        style={{
                            padding: "8px 16px",
                            backgroundColor: "#dc3545",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "14px",
                        }}
                    >
                        Logout
                    </button>
                </div>

                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "20px",
                        // @ts-ignore
                        "@media (max-width: 768px)": {
                            gridTemplateColumns: "1fr",
                        },
                    }}
                >
                    {/* Form Section */}
                    <div
                        style={{
                            backgroundColor: "white",
                            padding: "30px",
                            borderRadius: "8px",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <h2 style={{ marginTop: 0 }}>Query Parameters</h2>

                        <form onSubmit={handleApiSubmit}>
                            <div style={{ marginBottom: "20px" }}>
                                <label
                                    style={{
                                        display: "block",
                                        marginBottom: "5px",
                                        fontWeight: "500",
                                    }}
                                >
                                    Question
                                </label>
                                <textarea
                                    value={question}
                                    onChange={(e) =>
                                        setQuestion(e.target.value)
                                    }
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        border: "1px solid #ddd",
                                        borderRadius: "4px",
                                        fontSize: "16px",
                                        boxSizing: "border-box",
                                        minHeight: "80px",
                                        resize: "vertical",
                                    }}
                                    required
                                />
                            </div>

                            <div style={{ marginBottom: "20px" }}>
                                <label
                                    style={{
                                        display: "block",
                                        marginBottom: "5px",
                                        fontWeight: "500",
                                    }}
                                >
                                    Limit
                                </label>
                                <input
                                    type="number"
                                    value={limit}
                                    onChange={(e) => setLimit(e.target.value)}
                                    min="1"
                                    max="100"
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        border: "1px solid #ddd",
                                        borderRadius: "4px",
                                        fontSize: "16px",
                                        boxSizing: "border-box",
                                    }}
                                    required
                                />
                            </div>

                            <div style={{ marginBottom: "20px" }}>
                                <label
                                    style={{
                                        display: "block",
                                        marginBottom: "5px",
                                        fontWeight: "500",
                                    }}
                                >
                                    Min Relevance
                                </label>
                                <input
                                    type="number"
                                    value={minRelevance}
                                    onChange={(e) =>
                                        setMinRelevance(e.target.value)
                                    }
                                    min="0"
                                    max="1"
                                    step="0.1"
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        border: "1px solid #ddd",
                                        borderRadius: "4px",
                                        fontSize: "16px",
                                        boxSizing: "border-box",
                                    }}
                                    required
                                />
                            </div>

                            <div style={{ marginBottom: "20px" }}>
                                <label
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        fontWeight: "500",
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={debug}
                                        onChange={(e) =>
                                            setDebug(e.target.checked)
                                        }
                                        style={{
                                            marginRight: "8px",
                                            width: "18px",
                                            height: "18px",
                                            cursor: "pointer",
                                        }}
                                    />
                                    Debug Mode
                                </label>
                            </div>

                            <button
                                type="submit"
                                disabled={loading}
                                style={{
                                    width: "100%",
                                    padding: "12px",
                                    backgroundColor: loading
                                        ? "#6c757d"
                                        : "#28a745",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "4px",
                                    fontSize: "16px",
                                    fontWeight: "500",
                                    cursor: loading ? "not-allowed" : "pointer",
                                    transition: "background-color 0.2s",
                                }}
                            >
                                {loading
                                    ? "Sending Request..."
                                    : "Send Request"}
                            </button>
                        </form>
                    </div>

                    {/* Results Section */}
                    <div
                        style={{
                            backgroundColor: "white",
                            padding: "30px",
                            borderRadius: "8px",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <h2 style={{ marginTop: 0 }}>Response</h2>

                        {apiError && (
                            <div
                                style={{
                                    padding: "15px",
                                    backgroundColor: "#f8d7da",
                                    color: "#721c24",
                                    borderRadius: "4px",
                                    marginBottom: "20px",
                                    border: "1px solid #f5c6cb",
                                }}
                            >
                                <strong>Error:</strong> {apiError}
                            </div>
                        )}

                        {loading && (
                            <div
                                style={{
                                    padding: "20px",
                                    textAlign: "center",
                                    color: "#6c757d",
                                }}
                            >
                                Loading...
                            </div>
                        )}

                        {apiResponse && !loading && (
                            <pre
                                style={{
                                    backgroundColor: "#f8f9fa",
                                    padding: "15px",
                                    borderRadius: "4px",
                                    overflow: "auto",
                                    maxHeight: "500px",
                                    fontSize: "14px",
                                    lineHeight: "1.5",
                                    whiteSpace: "pre-wrap",
                                    wordWrap: "break-word",
                                }}
                            >
                                {apiResponse}
                            </pre>
                        )}

                        {!apiResponse && !loading && !apiError && (
                            <div
                                style={{
                                    padding: "20px",
                                    textAlign: "center",
                                    color: "#6c757d",
                                }}
                            >
                                Submit a query to see the response here
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
